module.exports = __webpack_public_path__ + "img/ic_remove_circle_outline.82299a65.svg";